import React from 'react';
import DocumentCard from '../../../components/fileManagement/components/DocumentCard';
import { API_AUTH_TYPES } from '../../../api';

const Vault = ({ document, query }) => {
    return (
        <DocumentCard
            document={document}
            authType={API_AUTH_TYPES.ADVISOR}
            query={query}
        />
    );
};

export default Vault; 